import { useEffect, useRef, useState } from "react";

// Re-runs `fn` every `interval` ms while the tab is visible, so bench users
// see other people's updates without hitting refresh.
export default function useLivePoll(fn, interval = 5000) {
  const ref = useRef(fn);
  const [lastSync, setLastSync] = useState(null);
  ref.current = fn;

  useEffect(() => {
    let timer = null;
    const tick = async () => {
      if (document.visibilityState !== "visible") return;
      try {
        await ref.current();
        setLastSync(new Date());
      } catch (e) { /* keep polling */ }
    };
    timer = setInterval(tick, interval);
    const onVisible = () => { if (document.visibilityState === "visible") tick(); };
    document.addEventListener("visibilitychange", onVisible);
    return () => { clearInterval(timer); document.removeEventListener("visibilitychange", onVisible); };
  }, [interval]);

  return lastSync;
}
